import * as React from 'react';
import ReactDom from 'react-dom';
import {AvailableContingentsClient} from "./Client";

export default ($el: HTMLElement) => {
    const applicationData = JSON.parse($el.dataset.application ?? "{}");
    const applicationRoot = $el.querySelector("[data-root=application]") as HTMLElement;

    if (applicationData.endpointUri && applicationRoot) {
        ReactDom.render(
            <AvailableContingentsClient
                applicationDocumentId={applicationData.applicationDocumentId}
                endpointUri={applicationData.endpointUri}
                countryOptions={applicationData.countryOptions}
                topicOptions={applicationData.topicOptions}
                teaserText={applicationData.teaserText}
            />,
            applicationRoot
        );

    }
}
